import LearningMilestoneDetails from "./LearningMilestoneDetails";

export default LearningMilestoneDetails;
